<div provide-parent-form *ngIf="lineup">

	<bb-form-element [form]="form" [label]="'NAME' | translate">
		<input [(ngModel)]="lineup.name" type="text" name="lineup_name" />
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'DESCRIPTION' | translate">
		<textarea [(ngModel)]="lineup.description" type="text" name="lineup_description"></textarea>
	</bb-form-element>
</div>
